/** Stable tour ids (persisted server-side, max 128 chars). */
export const NETWORK_MEMBERS_WELCOME_TOUR_ID = 'network_members_welcome_v1'
export const NETWORK_DASHBOARD_WELCOME_TOUR_ID = 'network_dashboard_welcome_v1'
export const COMMUNITY_DASHBOARD_WELCOME_TOUR_ID =
  'community_dashboard_welcome_v1'
export const RECURRING_BOOKING_TOUR_ID = 'recurring_booking_v1'

/** Query param to start a tour once after an action (e.g. network wizard). */
export const PRODUCT_TOUR_QUERY_PARAM = 'productTour'

/** DOM anchors for Driver.js (keep in sync with data-tour attributes). */
export const DATA_TOUR_NETWORK_MEMBERS = {
  invite: 'network-members-invite',
  invitationForm: 'invitation-form-fields',
  invitationShareLink: 'invitation-share-link',
  contextSwitcher: 'network-members-context-switcher',
  membersList: 'network-members-list',
} as const

export const DATA_TOUR_NETWORK_DASHBOARD = {
  stats: 'network-dashboard-stats',
  periodSelector: 'network-dashboard-period-selector',
  activity: 'network-dashboard-activity',
  topCommunities: 'network-dashboard-top-communities',
  newMembers: 'network-dashboard-new-members',
  fleet: 'network-dashboard-fleet',
  alerts: 'network-dashboard-alerts',
} as const

export const DATA_TOUR_COMMUNITY_DASHBOARD = {
  stats: 'community-dashboard-stats',
  periodSelector: 'community-dashboard-period-selector',
  bookings: 'community-dashboard-bookings',
  fleet: 'community-dashboard-fleet',
  alerts: 'community-dashboard-alerts',
} as const

export const DATA_TOUR_RECURRING_BOOKING = {
  typeSelector: 'recurring-booking-type-selector',
  configFields: 'recurring-booking-config-fields',
  calendarArea: 'recurring-booking-calendar-area',
} as const
